import type { NotificationListResponseNotificationsItem } from './notificationListResponseNotificationsItem';

export interface NotificationListResponse {
  notifications?: NotificationListResponseNotificationsItem[];
  unreadCount?: number;
}
